module.exports = __webpack_public_path__ + "img/5.75cbab7e.png";